import TaxInput from './TaxInput'

export default TaxInput
